export const NLP_CAROUSEL_DESKTOP_TITLE = 'New lower prices on hundreds of everyday items';
export const NLP_CAROUSEL_MOBILE_TITLE = 'New lower prices';
export const NLP_CAROUSEL_VIEW_ALL_LINK = '/ecom/shop/browse/groceries/new_lower_price';
export const NLP_CAROUSEL_VIEW_ALL_TITLE = 'View all';
